import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { refuseBatchPayment, resetRefuseBatchPayment } from "./refuse-batch-payment";

const initialState: ProcessingState = {
  processing: "idle",
};

export const refuseBatchPaymentReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(refuseBatchPayment.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(refuseBatchPayment.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(refuseBatchPayment.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetRefuseBatchPayment, () => {
    return initialState;
  });
});
